import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import MapFaker from './views/MapFaker.vue'
import Details from './views/Details.vue'

import AddPlace from '@/views/AddPlace'
import AddPick from '@/containers/AddPlace/AddPick'
import AddFirstStep from '@/containers/AddPlace/AddFirstStep'
import AddSecondStep from '@/containers/AddPlace/AddSecondStep'
import AddThirdStep from '@/containers/AddPlace/AddThirdStep'
import AddFourthStep from '@/containers/AddPlace/AddFourthStep'
import AddPlaceConfirmation from '@/containers/AddPlace/AddPlaceConfirmation'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/mapa/',
      name: 'map',
      component: MapFaker,
      children: [
        {
          path: ':id',
          name: 'details',
          component: Details
        }
      ]
    },
    {
      path: '/dodaj/',
      component: AddPlace,
      children: [
        {
          path: '',
          name: 'add-step-1',
          component: AddFirstStep
        },
        {
          path: 'wybierz',
          name: 'add-pick',
          component: AddPick
        },
        {
          path: 'krok-2',
          name: 'add-step-2',
          component: AddSecondStep
        },
        {
          path: 'krok-3',
          name: 'add-step-3',
          component: AddThirdStep
        },
        {
          path: 'krok-4/',
          name: 'add-step-4',
          component: AddFourthStep
        },
        {
          path: 'potwierdzenie/',
          name: 'add-thanks',
          component: AddPlaceConfirmation
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js